import React, { useContext } from 'react';
import { usePageWrapperData } from '@/app/common/pageWrapperProvider.tsx';
import { SearchModes } from '@/domainLogic/index.ts';
import { useCommonClient } from '@/app/common/commonClientProvider.tsx';
import { AgeText, PriceBottomContainer } from './styled';
import Taxes from './Taxes';
import type { DealCard } from '../../../../../utils/buildDealCards/dealCardTypes';
import { CardsContext } from '../../../../SearchPageContainer/ListContainer/CardsGrid/CardsContext.ts';
import { isOpxDeal } from '../../../utils/getPromotionsUtils.ts';

type PriceBottomProps = {
  isOverlay: boolean;
  taxesText: string | null;
  ageText: string;
  dealCard: DealCard;
  showTotalPrice: boolean;
};

const PriceBottom = ({ isOverlay, taxesText, ageText, dealCard, showTotalPrice }: PriceBottomProps) => {
  const { searchInfoData, localization } = usePageWrapperData();
  const { isMobile } = useCommonClient();
  const { searchParams, travellersCount } = useContext(CardsContext);
  const { isLiveSearch } = searchInfoData;
  const isDP = searchInfoData.searchMode === SearchModes.DP;
  const isDoublePricing = isDP && !!localization?.configValuesApp?.taxesIncludedDoublePricing && !isOverlay;
  const showAgeText = ageText && !isOverlay && !isLiveSearch;
  const isMobileOverlay = isMobile && isOverlay;
  const showTaxesText = taxesText && !isMobileOverlay;
  const showTaxes = (showTaxesText || isDoublePricing) && !isMobileOverlay && !isOpxDeal(dealCard);

  return showAgeText || showTaxes ? (
    <PriceBottomContainer className="price-bottom-container" isOverlay={isOverlay}>
      {showTaxes && (
        <Taxes
          isOverlay={isOverlay}
          taxesText={taxesText}
          dealCard={dealCard}
          showTotalPrice={showTotalPrice}
          searchParams={searchParams}
          travellersCount={travellersCount}
        />
      )}
      {showAgeText && <AgeText isOverlay={isOverlay}>{ageText}</AgeText>}
    </PriceBottomContainer>
  ) : null;
};

export default PriceBottom;
